import React from 'react';
import styled, { css } from '../../styled';
import Text from '../text';
import { getTranslation } from '../../utils';
import TabItem from './TabItem';
import TabIcon from './TabIcon';
import { MenuTextContainer, MultiLineTextContainer } from './TextContainer';
const TabIconWrapper = styled.div `
  display: flex;
  align-items: center;
  padding-right: 0.5rem;
`;
const FlexItem = styled.div `
  display: flex;
  padding: ${({ isDivider }) => (isDivider ? '0.25rem' : '0.5rem')} 0;
  padding-left: ${({ isDivider }) => (isDivider ? '1.5rem' : '1rem')};

  ${({ theme, leftBorderColor, isDivider }) => !isDivider &&
    css `
      border-left: 1px solid ${theme.colors[leftBorderColor]};
    `};

  ${({ isLastOfGroup }) => isLastOfGroup &&
    css `
      margin-bottom: 0.5rem;
      padding-top: 0.5rem;
      padding-bottom: 0;
    `};
`;
const SubTab = ({ e2eId, lang = 'zh-hant', isActived, type, nameTranslations, titleTranslations, subTitleTranslations, isLastOfGroup, icon, iconType, bgColor = 'INK_800', bgActiveColor = 'INK_700', bgHoverColor = 'INK_700', hoverColor, iconHoverColor, leftBorderColor = 'INK_400', }) => (React.createElement(TabItem, { "data-e2e-id": e2eId, className: type, isSubTab: true, isActived: isActived, isDivider: type === 'divider', bgColor: bgColor, bgActiveColor: bgActiveColor, bgHoverColor: bgHoverColor, hoverColor: hoverColor, iconHoverColor: iconHoverColor },
    React.createElement(FlexItem, { className: type === 'divider' ? undefined : 'with-left-border-block', isDivider: type === 'divider', isLastOfGroup: isLastOfGroup, leftBorderColor: leftBorderColor },
        icon && (React.createElement(TabIconWrapper, null,
            React.createElement(TabIcon, { icon: icon, iconType: iconType }))),
        nameTranslations ? (React.createElement(MenuTextContainer, { isDivider: type === 'divider' },
            React.createElement(Text, { fontType: type === 'divider' ? 'Micro' : 'Menu', lang: lang, color: "PRIMARY_A800" }, getTranslation(nameTranslations, lang)))) : (React.createElement(MultiLineTextContainer, null,
            React.createElement(Text, { fontType: "Body", lang: lang, color: "INK_600", weight: "Medium" }, titleTranslations && getTranslation(titleTranslations, lang)),
            React.createElement(Text, { fontType: "Micro", lang: lang, color: "INK_500" }, subTitleTranslations && getTranslation(subTitleTranslations, lang)))))));
export default SubTab;
//# sourceMappingURL=SubTab.js.map